import { useTranslation } from "react-i18next";
import { ShieldOffIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty-state";

interface AccessDeniedProps {
  title?: string;
  description?: string;
  onBack?: () => void;
}

export function AccessDenied({
  title = "Access Denied",
  description = "You don't have permission to access this page.",
  onBack,
}: AccessDeniedProps) {
  const { t } = useTranslation(["common", "company", "my-space"]);
  return (
    <div className="flex h-full items-center justify-center">
      <Empty>
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <ShieldOffIcon />
          </EmptyMedia>
          <EmptyTitle>{title}</EmptyTitle>
          <EmptyDescription>{description}</EmptyDescription>
        </EmptyHeader>
        {onBack && (
          <EmptyContent>
            <Button variant="outline" onClick={onBack}>
              {t("common:buttons.go_back")}
            </Button>
          </EmptyContent>
        )}
      </Empty>
    </div>
  );
}
